import React, { Component } from "react";
import Images from "../Images";

export class TopGamesDrawerIcon extends Component {
  render() {
    const {openTopGamesDrawer}=this.props
    return (
      <div className="drawer-icon">
        <div className="crown-wrapper">
          <img src={Images.Crown} onClick={() => openTopGamesDrawer()} />
        </div>
      </div>
    );
  }
}

export default TopGamesDrawerIcon;
